/**
 * Helpers para el lifecycle de la membresía — días restantes, formato de
 * fecha de vencimiento, severidad del aviso. ROUND12.
 */

export type LifecycleSeverity = 'ok' | 'soon' | 'critical' | 'expired';

/** Devuelve días enteros restantes hasta `expiresAtIso` (puede ser negativo). */
export function daysUntilExpiry(expiresAtIso: string | null | undefined): number | null {
  if (!expiresAtIso) return null;
  const t = new Date(expiresAtIso).getTime();
  if (!Number.isFinite(t)) return null;
  const msPerDay = 24 * 60 * 60 * 1000;
  return Math.ceil((t - Date.now()) / msPerDay);
}

/** Severidad UI según los umbrales pedidos por la orden ROUND12. */
export function lifecycleSeverity(daysLeft: number | null): LifecycleSeverity {
  if (daysLeft === null) return 'ok';
  if (daysLeft <= 0) return 'expired';
  if (daysLeft <= 2) return 'critical';
  if (daysLeft <= 7) return 'soon';
  return 'ok';
}

const SPANISH_MONTHS = [
  'ene',
  'feb',
  'mar',
  'abr',
  'may',
  'jun',
  'jul',
  'ago',
  'sep',
  'oct',
  'nov',
  'dic',
];

/** Formatea ISO → "DD/MMM/YYYY" en español (e.g. "26/may/2027"). */
export function formatExpiryDate(iso: string | null | undefined): string {
  if (!iso) return '—';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '—';
  const day = String(d.getDate()).padStart(2, '0');
  const month = SPANISH_MONTHS[d.getMonth()];
  const year = d.getFullYear();
  return `${day}/${month}/${year}`;
}

/** Etiqueta legible para el ciclo de suscripción. */
export function cycleLabel(cycle: 'monthly' | 'annual' | null | undefined): string {
  if (cycle === 'annual') return 'Anual';
  if (cycle === 'monthly') return 'Mensual';
  return '—';
}
